
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        paddingTop: "20px"
    },
    root: {
        flexGrow: 1,
    },
    // gridContainer: {
    //     columnCount: "5",
    //     columnWidth: "200px",
    //     columnGap: "10px",
    //     width: "100%",
    //     maxWidth: "1600px",
    //     margin: "auto",
    // },
    // gridItem: {
    //     margin: "0 auto 5px",
    //     width: "100%"
    // }
}));